export class TypeHelper
{
  public static numberEquals(a: number, b: number): boolean
  {
    return this.normalizeNumber(a) === this.normalizeNumber(b);
  }

  private static normalizeNumber(value: number): number
  {
    return value == null || Number.isNaN(value) ? null : value;
  }
}
